import React from 'react';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import Header from '../components/Elements/header/header';
import CustomButtons from '../components/Elements/Buttons/customButton';
import "./main.css"
import EDSFooter from '../components/EDSFooter';

const Login_error = () => {

    const [header, setHeader] = useState("/  AKTYWACJA KONTA")
    const key = localStorage.getItem("urlKey")
    const history = useHistory();
    const goToLogin = () => {
        let linkToPush;
       if(key == ""||key == null){
        linkToPush = '/LoginBuy'
       }else{
        linkToPush = '/LoginBuy/key=' + key
       }
         
         history.push(linkToPush);
    }
    return (
        <>
        <Header >{header}</Header>
          <div className="content responsive-padding">
              
              <main className="margin-top-64">
              <div className='tittle_wraper'>
          <p className="tittle_register">Błąd podczas logowania</p>
          <p className="tittle_register">Spróbuj zalogować się jeszcze raz</p>
        
         </div>
         <div className="custumerService_error margin-top-64">
                            <h2 className="h2 margin-top-16">INFOLINIA</h2>
                            <p className="margin-top-8">czynna od poniedziałku do piątku</p>
                            <p>w godzinach 9:00 - 17:00</p>
                            <p className="margin-top-16">tel.: 601 20 20 20</p>
                            <p>e-mail: studio@egurrola.pl</p>
                        </div>
         <div><CustomButtons clickFunction={(e)=>{goToLogin()}} classButton="solid" size="big">Zaloguj się</CustomButtons></div>
              </main>
          </div>
          <EDSFooter></EDSFooter>
      </>
    );
};
export default Login_error;
